import React, { useMemo, useState } from 'react';
import InputVertical from '../input/InputVertical';
var InputListVertical = function (_a) {
    var onBlur = _a.onBlur, onFocus = _a.onFocus, inputClassName = _a.inputClassName, value = _a.value, disabled = _a.disabled, className = _a.className, onChange = _a.onChange, name = _a.name, label = _a.label, autoFocus = _a.autoFocus, feedback = _a.feedback, invalid = _a.invalid, isRequired = _a.isRequired, max = _a.max, min = _a.min, placeholder = _a.placeholder, step = _a.step, type = _a.type, valid = _a.valid, listItems = _a.listItems, onClickItem = _a.onClickItem, size = _a.size, isRounded = _a.isRounded, helpText = _a.helpText, autoComplete = _a.autoComplete, id = _a.id;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var getItems = useMemo(function () {
        var items = listItems.map(function (item, index) { return (React.createElement("div", { className: 'list-item', onClick: function () {
                onClickItem(index);
                setIsOpen(false);
            }, key: index + Math.random() }, item)); });
        return items;
    }, [listItems, onClickItem]);
    var renderContent = useMemo(function () {
        return (React.createElement("div", { className: 'input-list ' + (className ? className : '') },
            React.createElement(InputVertical, { id: id, autoComplete: autoComplete, size: size, isRounded: isRounded, name: name, type: type, value: value !== null && value !== void 0 ? value : '', isRequired: isRequired, valid: valid, label: label, feedback: feedback, inputClassName: inputClassName, invalid: invalid, disabled: disabled, placeholder: placeholder, min: min, max: max, step: step, autoFocus: autoFocus, helpText: helpText, onFocus: function () {
                    setIsOpen(true);
                    onFocus && onFocus();
                }, onBlur: function () {
                    onBlur && onBlur();
                    setTimeout(function () {
                        setIsOpen(false);
                    }, 170);
                }, className: inputClassName, onChange: onChange }),
            listItems && listItems.length !== 0 && (React.createElement("div", { className: 'list custom-scroll ' +
                    (isRounded ? 'round-list ' : '') +
                    (isOpen ? 'show ' : '') +
                    (size === 'sm' ? 'sm-list' : '') }, getItems))));
    }, [
        id,
        autoComplete,
        autoFocus,
        className,
        disabled,
        feedback,
        getItems,
        helpText,
        inputClassName,
        invalid,
        isOpen,
        isRequired,
        isRounded,
        label,
        listItems,
        max,
        min,
        name,
        onBlur,
        onChange,
        onFocus,
        placeholder,
        size,
        step,
        type,
        valid,
        value,
    ]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { InputListVertical };
//# sourceMappingURL=InputListVertical.js.map